import React from "react";
import "./PageHeader.scss";

interface ICrumb {
  label: string;
  onClick?: () => void;
}

interface IPageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  crumbs?: ICrumb[];
  actions?: React.ReactNode;
}

const PageHeader: React.FC<IPageHeaderProps> = ({ title, subtitle, crumbs, actions }) => {
  return (
    <div className="page-header">
      {crumbs && crumbs.length > 0 && (
        <nav className="page-header__crumbs" aria-label="Breadcrumb">
          {crumbs.map((c, i) => (
            <span key={i} className="page-header__crumb">
              {i > 0 && <span className="page-header__sep">›</span>}
              {c.onClick ? (
                <button type="button" className="page-header__crumb-link" onClick={c.onClick}>
                  {c.label}
                </button>
              ) : (
                <span className="page-header__crumb-current">{c.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}
      <div className="page-header__row">
        <div className="page-header__text">
          <h1 className="page-header__title">{title}</h1>
          {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
